// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"SettingsButton_ProseMirror__iIBz3","btnSettings":"SettingsButton_btnSettings__3TdBL","btnSettings__icon":"SettingsButton_btnSettings__icon__3q942"};